define('tddropdown', ['jquery'], function ($) {

  var tddropdown = {
    init: function init(reinit) {
      this.reinit = reinit;
      if ($('.product__form .product__dropdown').length > 0) {
        this.setDropdowList();
      }
    },
    setDropdowList: function setDropdowList() {

      var formValue = 'default';
      var formAttribute = null;
      var isDropdownOpen = this.isDropdownOpen();
      if (typeof configAttributes != 'undefined') {
        if ((formAttribute = jQuery('#attribute' + configAttributes['config_product_option_form'])) && formAttribute.length) {
          if (formAttribute.val()) {
            formValue = formAttribute.val();
          } else {
            formValue = formAttribute.find('option[value!=""]').val();
          }
        }
      }

      $('.product__dropdown').each(function (index, el) {
        var self = $(el);
        var selectid = self.data('selectid');
        var select = self.parent().find('select');
        var dropdownUl = self.find('.product__list');
        var dropdownTitle = self.find('.chosen-value-title').text();

        var isCurrentDropdownOpen = self.parent().hasClass('frontend-special');

        if (dropdownUl.children().length != 0) {
          dropdownUl.children().remove();
        }

        if (dropdownUl.children().length == 0) {
          var zeroPriceShowFlag = false;
          select.find('option:not([disabled])').each(function () {
            if (typeof $(this).attr('price') !== 'undefined' || typeof $(this).data('price') !== 'undefined') {
              if (!dropdownTitle.includes('Grösse') && ($(this).attr('price') == 0 || $(this).data('price') == '0.00')) {
                return true;
              } else {
                zeroPriceShowFlag = true;
                return false;
              }
            }
          });

          var items = select.find('option:not([disabled])').map(function () {
            var option = $(this);
            var value = option.val();
            var formattedLabel = option.attr('data-label') || '';
            var colorhex = option.data('color');
            var dataEnabled = option.attr('data-enabled') || true;
            var selectId = select.attr('id').replace(/^attribute/, '');
            var floorImageAttribute = typeof floorImageAttributesData != 'undefined' ? floorImageAttributesData[selectId] : null;
            var textFormated = "";

            if (option.html().includes("CHF&nbsp;") && (dropdownTitle.includes('Antirutschunterlage:') || dropdownTitle.includes('Fleckenschutz:') || dropdownTitle.includes('Fussleiste:'))) {
              textFormated = option.html().split("CHF&nbsp;")[0].trim();
            } else {
              var text = option.text().replace(/\(|\)/g, '').split(' ');
              textFormated = "<span class=\"variant\">";

              text.forEach(function (el, i) {
                if (!zeroPriceShowFlag && !dropdownTitle.includes('Grösse') && (option.attr('price') == 0 || option.data('price') == '0.00')) {
                  var elArr = el.split('CHF');
                  el = $.trim(elArr[0]);
                }
                if (option.data('final-price') == option.data('regular-price')) {
                  return textFormated += el.includes('CHF') && i === text.length - 1 ? '</span><span class="price bold">' + el + '</span>' : el + ' ';
                }

                return textFormated += el.includes('CHF') && i === text.length - 1 ? '</span><span data-final-price="' + option.data('final-price') + '" data-regular-price="' + option.data('regular-price') + '" class="price bold final">' + el + '</span>' : el + ' ';
              });
            }

            if (isCurrentDropdownOpen) {
              textFormated = textFormated.replace("|", "<br/>");
            }

            if (formattedLabel !== 'none' && formattedLabel !== 'kein wert' && value.length > 0) {
              if (!!colorhex) {
                dropdownUl.append('<li data-enabled="' + dataEnabled + '">\n                  <a data-selectid="' + selectid + '" data-selectvalue="' + value + '" href="javascript:void(0);" data-colorhex="' + colorhex + '" onclick="window.tddropdown.change(this);">\n                    <div style="background:' + colorhex + '"></div>\n                    ' + textFormated + '\n                  </a>\n                </li>\n                ');
              } else if (option.attr('data-image') || floorImageAttribute && typeof floorImageAttributesData[selectId][value] != 'undefined') {
                var selectValue = null;
                if (option.attr('data-image')) {
                  selectValue = option.attr('data-image');
                } else {
                  if (selectId == configAttributes['config_product_option_farbe']) {
                    selectValue = floorImageAttributesData[selectId][value][formValue];
                  } else {
                    selectValue = floorImageAttributesData[selectId][value];
                  }
                }
                dropdownUl.append('<li data-enabled="' + dataEnabled + '" title="' + formattedLabel + '">\n                    <a data-selectid="' + selectid + '" data-selectvalue="' + value + '" href="javascript:void(0);" onclick="window.tddropdown.change(this);">\n                      <span class="option-value-wrap">\n                        <span class="option-swatch"><img src="' + selectValue + '"/></span>\n                         ' + textFormated + '\n                      </span>\n                    </a>\n                    </li>\n                ');
              } else {
                dropdownUl.append('<li data-enabled="' + dataEnabled + '">\n                  <a data-selectid="' + selectid + '" data-selectvalue="' + value + '" href="javascript:void(0);" onclick="window.tddropdown.change(this);">\n                    ' + textFormated + '\n                  </a>\n                </li>\n                ');
              }
            }
          });

          var selectedOption = select.find('option:selected');

          if (selectedOption.length && selectedOption.val()) {
            if (dropdownUl.find('[data-selectvalue="' + selectedOption.val() + '"] .option-value-wrap').length) {
              var selectedOptionText = dropdownUl.find('[data-selectvalue="' + selectedOption.val() + '"] .option-value-wrap').html(),
                  chosen_value = selectedOptionText.split('CHF');
              self.find('.chosen-value').html($.trim(chosen_value[0]));
            } else {
              if (selectedOption.html().includes("CHF&nbsp;") && (dropdownTitle.includes('Antirutschunterlage:') || dropdownTitle.includes('Fleckenschutz:') || dropdownTitle.includes('Fussleiste:'))) {
                self.find('.chosen-value').text(selectedOption.html().split("CHF&nbsp;")[0].trim());
              } else {
                var selectedOptionText = selectedOption.text(),
                    chosen_value = selectedOptionText.split('CHF');
                self.find('.chosen-value').text($.trim(chosen_value[0]));
              }
            }

            if (isDropdownOpen) {
              select.closest('div').find('.product__list li a[data-selectvalue="' + selectedOption.val() + '"]').closest('a').after('<span class="checkmark"></span>').closest('li').addClass('active');
            }
          }
        }
      });

      if (!!this.reinit) {
        $('div.dropDown p').oxDropDown();
      }

      // Remove price part from label
      jQuery('.product__selector .chosen-value').each(function () {
        // var label = jQuery(this);
        // if ((label.text().indexOf('CHF') != -1)) {
        //   label.text(label.text().replace(/\(CHF.*\)/, ''));
        // }
      });
    },
    change: function change(el) {
      var self = $(el);
      var selectvalue = self.data('selectvalue');
      var selectid = self.data('selectid');
      var select = $('#' + selectid);

      select.val(selectvalue).find('option[value="' + selectvalue + '"]').prop('selected', true);

      if (selectvalue) {
        select.removeClass('js_error'); // there is value already, so remove validation error from dropdown
      }

      customEvent(selectid, 'change');
      //HACK to reload options
      if (select.hasClass('super-attribute-select')) {
        if (typeof spConfig !== 'undefined') {
          spConfig.reloadPrice();
        }
      }

      if (window.customproduct) {
        this.customProductVariantChange(self);
      }
    },
    customProductVariantChange: function customProductVariantChange(el) {
      var dimensions = el.find('.variant').text().replace('cm', '').trim().split('x');
      var width = Number.parseFloat(dimensions[0]) / 100;
      var height = Number.parseFloat(dimensions[1]) / 100;
      if (width && height) window.customproduct.changeVariant([width, height]);
    },

    isDropdownOpen: function isDropdownOpen() {
      return $('.product__form--wrapper').data('frontend_special') === 'Offene Attribute und Dropdowns';
    }
  };
  window.tddropdown = tddropdown;
  return tddropdown;
});

